import { useEffect, useState } from "react";
import { Avatar, AvatarImage, AvatarFallback } from "../../ui/avatar"
import { getVideoHistoryFileUrl } from "../live-campaign-repository"

export const VersionHistoryHeader = ({ videoVersionHistory }) => {
  const [imageUrl, setImageUrl] = useState(null);

  const creatorProfileId = videoVersionHistory?.creatorProfileId;

  useEffect(() => {
    const fetchImageUrl = async () => {
      if (creatorProfileId) {
        const url = await getVideoHistoryFileUrl(creatorProfileId);
        setImageUrl(url);
      }
    };

    fetchImageUrl();
  }, [creatorProfileId]);

  return (
    <div className="bg-white rounded-lg border shadow-sm p-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Avatar className="w-12 h-12">
            <AvatarImage src={imageUrl} alt={videoVersionHistory && videoVersionHistory.creatorProfileId} />
            <AvatarFallback>{videoVersionHistory && videoVersionHistory.creatorName.charAt(0)}</AvatarFallback>
          </Avatar>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Version History
            </h1>
            <p className="text-gray-600">
              Creator: <span className="font-medium">{videoVersionHistory && videoVersionHistory.creatorName}</span> (@
              {videoVersionHistory && videoVersionHistory.creatorInstahandle})
            </p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm text-gray-500">Total Versions</p>
          <p className="text-2xl font-bold text-[#f06292]">{videoVersionHistory && videoVersionHistory.videoVersions && videoVersionHistory.videoVersions.length}</p>
        </div>
      </div>
    </div>
  )
}
